var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPairCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39107 8.5C10.5522 8.5 12.3041 6.82107 12.3041 4.75C12.3041 2.67893 10.5522 1 8.39107 1C6.22996 1 4.47803 2.67893 4.47803 4.75C4.47803 6.82107 6.22996 8.5 8.39107 8.5Z",
    stroke: "#FF6C6C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.0003V17.4289C1 16.166 1.51163 14.9547 2.42234 14.0617C3.33306 13.1687 4.56826 12.667 5.8562 12.667H10.7124C11.564 12.6678 12.4004 12.8882 13.1377 13.3061C13.875 13.724 14.4872 14.3248 14.913 15.0479",
    stroke: "#FF6C6C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3623 21L21 16",
    stroke: "#FF6C6C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1812 20.8188L16.1812 16.1812",
    stroke: "#FF6C6C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairCancel);
export default __webpack_public_path__ + "static/media/pair-cancel.398155ef8ad4cd34bb8d4cc2fc60d2da.svg";
export { ForwardRef as ReactComponent };